// BaseTable.js
import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Typography,
} from "@mui/material";
import { connect } from "react-redux";
import Filter from "./Filter";


export const buildQuery = (filters, currentPage, limit) => {
  let query = "";

  // Add filter values to the query
  const activeFilters = filters.filter((filter) => {
    if (!filter.value) return false;

    // Handle date range filter (value is { startDate, endDate })
    if (filter.type === "date") {
      return filter.value.startDate && filter.value.endDate;
    }

    // Handle array filters (e.g., multi-select)
    if (Array.isArray(filter.value)) {
      return filter.value.length > 0;
    }

    // Handle string/number filters
    return filter.value !== "";
  });

  // Build the filter part of the query
  const filterQueryParts = [];
  activeFilters.forEach((filter) => {
    if (filter.type === "date") {
      // Format date range as `startDate=YYYY-MM-DD&endDate=YYYY-MM-DD`
      const { startDate, endDate } = filter.value;
      filterQueryParts.push(`startDate=${formatDate(startDate)}`);
      filterQueryParts.push(`endDate=${formatDate(endDate)}`);
    } else if (Array.isArray(filter.value)) {
      filterQueryParts.push(
        `${filter.name}=${filter.value.map((v) => encodeURIComponent(v)).join(",")}`
      );
    } else {
      filterQueryParts.push(`${filter.name}=${encodeURIComponent(filter.value)}`);
    }
  });

  // Add filters to query (if any)
  if (filterQueryParts.length > 0) {
    query += "?" + filterQueryParts.join("&");
  }

  // Add pagination (if filters exist)
  if (filterQueryParts.length > 0) {
    if (currentPage) query += `&page=${currentPage}`;
    if (limit) query += `&pageSize=${limit}`;
  } else {
    // No filters, only pagination
    if (currentPage) query += `?page=${currentPage}`;
    if (limit && currentPage) query += `&pageSize=${limit}`;
    else if (limit) query += `?pageSize=${limit}`;
  }

  return query;
};

// Helper: Format date to YYYY-MM-DD
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toISOString().split("T")[0];
};


const BaseTable = ({
  rows,
  // fetchData,
  isLoading,
  headers,
  renderRows,
  showPagination,
  paginationParams,
  setPaginationParams,
  currentPage,
  limit,
  isFilter,
  filters,
  handleFilterClick,
  handleExportData,
  height,
}) => {

  // useEffect(() => {
  //   if (currentPage && limit) {
  //     const query = buildQuery(filters, currentPage, limit);
  //     fetchData(query);
  //   } else {
  //     fetchData();
  //   }
  // }, [currentPage, limit, fetchData, filters]);


  const handlePageChange = (event, newPage) => {
    setPaginationParams((prevState) => ({
      ...prevState,
      currentPage: newPage + 1,
    }));
  };


  const handleRowsPerPageChange = (event) => {
    setPaginationParams((prevState) => ({
      ...prevState,
      limit: parseInt(event.target.value, 10),
      currentPage: 1,
    }));
  };

  return (
    <Paper>
      {isFilter && (
        <Filter filterDataArr={filters} handleFilterClick={handleFilterClick} handleExportData={handleExportData} />
      )}
      <TableContainer
        component={Paper}
        sx={{
          border: "1px solid #273334",
          maxHeight: height || "380px",
          marginTop: '2px',
          "& th": {
            color: "#fff",
          },
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="headerBorder">
              {headers &&
                headers?.map((header, index) => (
                  <TableCell
                    key={index}
                    align={header.align}
                  // sx={{
                  //   position: "sticky",
                  //   top: 0,
                  //   backgroundColor: "#0f1c1e",
                  //   zIndex: 1,
                  // }}
                  >
                    {header.label}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              color: "#fff",
              overflowY: "auto",
              maxHeight: "calc(500px - 98px)",
            }}
          >
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={headers?.length} align="center">
                  <h1>Loading...</h1>
                </TableCell>
              </TableRow>
            ) : rows?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headers?.length} align="center">
                  <Typography>No data found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              renderRows()
            )}
          </TableBody>
        </Table>

      </TableContainer>
      {showPagination && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={paginationParams?.totalRecords || 0}
          rowsPerPage={limit || 0}
          page={(currentPage || 1) - 1}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />

      )}
    </Paper>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(BaseTable);
